"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  optValue: 'no_education',
  optLabel: 'education.no_education'
}, {
  optValue: 'elementary',
  optLabel: 'education.elementary'
}, {
  optValue: 'some_high_school',
  optLabel: 'education.some_high_school'
}, {
  optValue: 'high_school',
  optLabel: 'education.high_school'
}, {
  optValue: 'college',
  optLabel: 'education.college'
}, {
  optValue: 'degree',
  optLabel: 'education.degree'
}, {
  optValue: 'some_postgraduate',
  optLabel: 'education.some_postgraduate'
}, {
  optValue: 'postgraduate',
  optLabel: 'education.postgraduate'
}, {
  optValue: 'prefer_not_answer',
  optLabel: 'education.prefer_not_answer'
}];
exports.default = _default;